import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-[16px] flex h-10 items-center rounded-[111px] transition-opacity duration-200 lg:mt-[24px]'
  },
  variants: {
    isLoaded: {
      true: 'bg-blue-light opacity-100',
      false: 'opacity-0'
    }
  },
  defaultVariants: {
    isLoaded: false
  }
});
